var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{style:(`max-width : ${_vm.width}; max-height:${_vm.height}`)},[_c('video',{staticClass:"video-js",attrs:{"id":"video","preload":"none","crossorigin":"true","controls":"","width":_vm.width,"height":_vm.height,"muted":""},domProps:{"muted":true}})])
}
var staticRenderFns = []

export { render, staticRenderFns }